import theme from '../theme'
import { makeStyles } from '@material-ui/core'

const html = {
  WebkitFontSmoothing: 'antialiased', // Antialiasing.
  MozOsxFontSmoothing: 'grayscale', // Antialiasing.
  fontFamily: "'Barlow', sans-serif",
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: 'border-box',
  // Fix font resize problem in iOS
  WebkitTextSizeAdjust: '100%',
}

const body = {
  color: theme.palette.text.primary,
  ...theme.typography.body2,
  backgroundColor: theme.palette.background.default + ' !important',
  fontFamily: "'Barlow', sans-serif",
  '@media print': {
    // Save printer ink.
    backgroundColor: theme.palette.common.white,
  },
}
const styleOverride = makeStyles({
  '@global': {
    '@import':
      'url("https://fonts.googleapis.com/css2?family=Barlow:wght@100;200;300;400;500;600;700&display=swap")',
    html,
    '*, *::before, *::after': {
      boxSizing: 'inherit',
    },
    'strong, b': {
      fontWeight: theme.typography.fontWeightBold,
    },
    body: {
      margin: 0, // Remove the margin in all browsers.
      ...body,
      // Add support for document.body.requestFullScreen().
      // Other elements, if background transparent, are not supported.
      '&::backdrop': {
        backgroundColor: theme.palette.background.default,
      },
    },
    '.button--no-style': {
      background: 'none',
      color: 'inherit',
      border: 'none',
      padding: '0',
      font: 'inherit',
      cursor: 'pointer',
      outline: 'inherit'
    }
  },
})
export default styleOverride
